import "core-js/modules/es6.object.define-properties";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.array.filter";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.object.define-property";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.from";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.date.to-string";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.is-array";
import "core-js/modules/es6.function.name";
import _find from "lodash/find";
import _some from "lodash/some";
import _sumBy from "lodash/sumBy";
import _orderBy from "lodash/orderBy";
import _map from "lodash/map";
import _filter from "lodash/filter";
import _reduce from "lodash/reduce";
import _size from "lodash/size";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

import moment from 'moment';
import { BILL_FREQUENCIES, CANONICAL_BILLER_NAMES } from "../constants";
export var computeMonthlyBasisBillSpend = function computeMonthlyBasisBillSpend(bill) {
  if (!bill) {
    return null;
  }

  var amount = bill.amount,
      frequency = bill.frequency;

  switch (frequency) {
    case BILL_FREQUENCIES.WEEKLY:
      return amount * 4;

    case BILL_FREQUENCIES.EVERY_OTHER_WEEK:
      return amount * 2;

    case BILL_FREQUENCIES.MONTHLY:
      return amount;

    case BILL_FREQUENCIES.EVERY_OTHER_MONTH:
      return amount / 2;

    case BILL_FREQUENCIES.QUARTERLY:
      return amount / 3;

    case BILL_FREQUENCIES.TWICE_A_YEAR:
      return amount / 6;

    case BILL_FREQUENCIES.ANNUALLY:
      return amount / 12;

    default:
      return 0;
  }
};
export var computeAverageMonthlyBillsSpend = function computeAverageMonthlyBillsSpend(bills) {
  var numBills = _size(bills);

  if (numBills < 1) {
    return 0;
  }

  return _reduce(bills, function (sum, bill) {
    return sum + computeMonthlyBasisBillSpend(bill);
  }, 0);
};
/**
 * Returns a list of bill instances whose due dates are between minDate and
 * maxDate (inclusive), sorted by next due date.
 *
 * Bill instances are based off a list of master bill objects from the myBills
 * param.
 *
 * @param {Object[]}  myBills Bills
 * @param {string} minDate  Date as YYYY-MM-DD
 * @param {string} maxDate  Date as YYYY-MM-DD
 *
 * @return {Object[]} Array of predicted bills
 */

export var createBillInstances = function createBillInstances(myBills, minDate, maxDate) {
  if (!myBills || !minDate || !maxDate) {
    return null;
  }

  if (moment(minDate).isAfter(maxDate)) {
    // TODO: only warn in dev
    // eslint-disable-next-line no-console -- directive added automatically by Shepherd migration
    console.warn('minDate must be before maxDate');
    return [];
  }

  var allBillInstances = _reduce(myBills, function (acc, bill) {
    var allDates = [].concat(_toConsumableArray(bill.past_due_dates || []), _toConsumableArray(bill.next_due_dates || []));

    var datesWithinRange = _filter(allDates, function (date) {
      return moment(date).isBetween(minDate, maxDate, 'days', '[]');
    });

    var instances = _map(datesWithinRange, function (date) {
      return _objectSpread(_objectSpread({}, bill), {}, {
        next_due_date: date
      });
    });

    return [].concat(_toConsumableArray(acc), _toConsumableArray(instances));
  }, []);

  return _orderBy(allBillInstances, ['next_due_date', 'amount'], ['asc', 'desc']);
};
/**
 * Returns the sum of amounts for unpaid bill instances between minDate and
 * maxDate (inclusive).
 *
 * @param {Object[]} billInstances A list of bill instances
 * @param {string} minDate  Date as YYYY-MM-DD
 * @param {string} maxDate  Date as YYYY-MM-DD
 */

export var computeUpcomingBillsTotal = function computeUpcomingBillsTotal(billInstances, minDate, maxDate) {
  if (!billInstances || !minDate || !maxDate) {
    return null;
  }

  var upcomingBills = _filter(billInstances, function (_ref) {
    var nextDueDate = _ref.next_due_date,
        paidDate = _ref.paid_date;

    if (paidDate) {
      return moment(nextDueDate).isBetween(minDate, maxDate, 'days', '[]') && // Only the next expected bill can be marked as paid
      // If bill is marked as paid, exclude it from "upcoming bills" calculation
      paidDate !== nextDueDate;
    }

    return moment(nextDueDate).isBetween(minDate, maxDate, 'days', '[]');
  });

  return _sumBy(upcomingBills, 'amount');
};
/**
 * Returns true if billName is already taken by another bill
 *
 * @param {string}  billName the name to validate
 * @param {Array}  myBills the user's bills (from myBills state)
 * @param {Array} stagedBills  the user's staged bills
 *
 * @return {boolean} true if billName is taken
 */

export var getIsDuplicateBillName = function getIsDuplicateBillName(_ref2) {
  var name = _ref2.name,
      id = _ref2.id,
      myBills = _ref2.myBills,
      stagedBills = _ref2.stagedBills;
  var allBills = [].concat(_toConsumableArray(myBills || []), _toConsumableArray(stagedBills || []));
  return _some(allBills, function (bill) {
    return bill.name === name && bill.id !== id;
  });
};
/**
 * Returns a bill from an array of bill objects.
 *
 * @param {Object[]} bills
 * @param {string} billId
 *
 * @return {Object} A bill matching billId
 */

export var findBillById = function findBillById(bills, billId) {
  return _find(bills, {
    id: billId
  });
};
/**
 * Returns the canonical biller name for a case-insensitive biller.
 *
 * @param {string} biller Biller name
 *
 * @return {string|null} Canonical biller name
 */

export var getCanonicalBillerName = function getCanonicalBillerName(biller) {
  if (!biller) {
    return null;
  }

  switch (biller.toLowerCase()) {
    case 'apple inc':
    case 'apple inc.':
    case 'itunes':
      return CANONICAL_BILLER_NAMES.APPLE;

    case 'at&t':
      return CANONICAL_BILLER_NAMES.ATT;

    case 'capital one':
      return CANONICAL_BILLER_NAMES.CAPITAL_ONE;

    case 'comcast':
      return CANONICAL_BILLER_NAMES.COMCAST;

    case 'cox communications':
      return CANONICAL_BILLER_NAMES.COX;

    case 'geico':
      return CANONICAL_BILLER_NAMES.GEICO;

    case 'navient':
      return CANONICAL_BILLER_NAMES.NAVIENT;

    case 'netflix':
      return CANONICAL_BILLER_NAMES.NETFLIX;

    case 'sallie mae':
      return CANONICAL_BILLER_NAMES.SALLIE_MAE;

    case 'spotify':
    case 'spotify ltd':
      return CANONICAL_BILLER_NAMES.SPOTIFY;

    case 'sprint':
      return CANONICAL_BILLER_NAMES.SPRINT;

    case 'state farm bank':
    case 'state farm insurance':
      return CANONICAL_BILLER_NAMES.STATE_FARM;

    case 't-mobile':
      return CANONICAL_BILLER_NAMES.T_MOBILE;

    case 'venmo':
    case 'venmo inc':
      return CANONICAL_BILLER_NAMES.VENMO;

    case 'verizon':
    case 'verizon wireless':
      return CANONICAL_BILLER_NAMES.VERIZON;

    case 'xfinity':
      return CANONICAL_BILLER_NAMES.XFINITY;

    default:
      return null;
  }
};
/**
 * Returns true if the next bill instance was marked as paid else false
 *
 * @param {Object} bill
 *
 * @return {boolean} is the next bill instance paid
 */

export var getIsBillMarkedAsPaid = function getIsBillMarkedAsPaid(bill) {
  var paidDate = bill.paid_date,
      nextDueDate = bill.next_due_date;

  if (!nextDueDate || !paidDate) {
    return false;
  }

  return moment(paidDate).isSameOrAfter(nextDueDate);
};